import React from 'react'

const DoubleArrowIcon = ({width,height}) => {
  return (
    <svg className="animationScrollToGallery" width={width ? width : "66" } height={height ? height : "95" } viewBox="0 0 66 95" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.5 33L33.21 61.71L61.92 33" stroke="white" stroke-opacity="0.47" stroke-width="7.1775" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 62L32.71 90.71L61.42 62" stroke="white" stroke-width="7.1775" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4 4L32.71 32.71L61.42 4" stroke="white" stroke-opacity="0.17" stroke-width="7.1775" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default DoubleArrowIcon